export default __webpack_public_path__ + "static/media/section1-bg2.d7d6ec5b.svg";